import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a334a7e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "identity-verification"
};
const _hoisted_2 = {
  class: "identity-verification-content"
};
const _hoisted_3 = {
  class: "main-img"
};
const _hoisted_4 = {
  class: "verification-agreement"
};
const _hoisted_5 = {
  class: "agreement-text"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["src"];
import { ref, reactive, getCurrentInstance, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { showToast } from "vant";
import { showConfirmDialog } from "vant";
import { MainButton, AgreementView } from '@/components';
import { realAuthIdApi } from '@/api/identityVerification';
import { agreement, synUserAgreeVersion } from '@/api/informationSafety/agreement';
import { fullScreen, openLoginPage, checkCamera, settingController } from '@/utils/navitiveApi/common';
import { matchPhone } from '@/utils/tools';
export default /*#__PURE__*/_defineComponent({
  __name: 'IdentityVerificationGab',
  setup(__props) {
    var _getCurrentInstance$p, _getCurrentInstance;
    const {
      isIOS
    } = matchPhone();
    const {
      $alert,
      $loading
    } = (_getCurrentInstance$p = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy) !== null && _getCurrentInstance$p !== void 0 ? _getCurrentInstance$p : {};
    const route = useRoute();
    const router = useRouter();
    const disabled = ref(true);
    // checkbox icon
    const agreementCheckedImg = require('@/assets/image/verification-agreement-checked.png');
    const agreementUncheckedImg = require('@/assets/image/verification-agreement-unchecked.png');
    const from = ref('');
    const userInfo = reactive({
      idcardName: '',
      idcardNumber: ''
    });
    const agreementChecked = ref(false);
    const agreementViewShow = ref(false);
    const agreementHtml = ref('');
    const agreementUrl = ref('');
    const agreeCode = ref('');
    const agreeVersion = ref('');
    const openIdentityAuthorization = () => {
      console.info('点击身份认证服务授权书');
    };
    //监听信息是否为空，展示按钮高亮
    watch(() => [userInfo.idcardName, userInfo.idcardNumber], ([newidcardName, newidcardNumber], [oldidcardName, oldidcardNumber]) => {
      console.log('idcardName', newidcardName, 'idcardNumber', newidcardNumber);
      if (newidcardName !== '' && newidcardNumber !== '') {
        disabled.value = false;
      } else {
        disabled.value = true;
      }
    });
    // 打开隐私协议
    const openAgreement = async () => {
      try {
        const request = {
          agreeCode: 'privacy'
        };
        const {
          code,
          data,
          message
        } = await agreement(request);
        $loading.closeLoading();
        if (code !== 9000) {
          $alert({
            message
          }).then(() => {
            if (code === 9008) {
              openLoginPage();
            }
          });
          return;
        }
        agreementHtml.value = data.authAgreeContent;
        agreementUrl.value = '';
        agreementViewShow.value = true;
      } catch (error) {
        console.error(error);
      }
    };
    // 打开实名认证页面获取隐私协议版本号，不进行错误处理
    const getAgreement = async () => {
      const request = {
        agreeCode: 'privacy'
      };
      const {
        code,
        data,
        message
      } = await agreement(request);
      $loading.closeLoading();
      agreeVersion.value = data.agreeVersion;
      agreeCode.value = data.agreeCode;
    };
    // 打开使用协议
    const openPassport = () => {
      agreementHtml.value = '';
      agreementUrl.value = process.env.VUE_APP_PASSPORT_PROTOCAL;
      agreementViewShow.value = true;
    };
    // 检查表单
    const checkForm = () => {
      const {
        idcardName,
        idcardNumber
      } = userInfo;
      if (!idcardName) {
        showToast({
          message: '请输入用户姓名',
          position: 'top'
        });
        return false;
      }
      if (!idcardNumber) {
        showToast({
          message: '请输入用户身份证号',
          position: 'top'
        });
        return false;
      }
      const idNoReg = /^[1-9]\d{5}(19|20|21)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!idNoReg.test(idcardNumber)) {
        showToast({
          message: '请输入正确的身份证号',
          position: 'top'
        });
        return false;
      }
      if (!agreementChecked.value) {
        showToast({
          message: '请勾选用户协议',
          position: 'top'
        });
        return false;
      }
      return true;
    };
    // 认证接口时再调用一次更新用户隐私协议版本号
    const updateUserAgreeVersion = async () => {
      try {
        const param = {
          agreementList: [{
            agreeCode: agreeCode.value,
            agreeVersion: agreeVersion.value
          }],
          operateType: '02',
          updateRzAgreeFlag: true
        };
        await synUserAgreeVersion(param);
      } catch (e) {
        console.info('更新用户签署协议版本失败', e);
      }
    };
    // 提交
    const goVerify = async () => {
      // 检查表单
      if (!checkForm()) return;
      //检测相机是否开启
      const res = await cameraOpen();
      if (!res) return;
      $loading.openLoading();
      await updateUserAgreeVersion();
      const {
        idcardName,
        idcardNumber
      } = userInfo;
      // const param = new FormData()
      // param.append('idcardName', idcardName)
      // param.append('idcardNumber', idcardNumber)
      const param = {
        name: idcardName,
        idNo: idcardNumber
      };
      try {
        const {
          code,
          data,
          message
        } = await realAuthIdApi(param);
        // console.info('实名认证 code', code, 'message', message)
        $loading.closeLoading();
        // 如果是9008，要重新登录，其他情况按接口提示文案展示
        if (code === 9008) {
          $alert({
            message
          }).then(() => {
            openLoginPage();
          });
          return;
        } else if (code !== 9000 && code !== 9012) {
          $alert({
            message
          });
          return;
        }
        window.sessionStorage.setItem('orderNo', '');
        window.sessionStorage.setItem('source', 'h5');
        window.sessionStorage.setItem('path', route.path);
        window.sessionStorage.setItem('verificationResult', JSON.stringify(Object.assign({}, data, {
          code,
          message
        })));
        router.push({
          path: 'verificationResult'
        });
        // console.log('data', data)
        // const { faceAddr, orderNo } = data
        // window.sessionStorage.setItem('orderNo', orderNo)
        // window.sessionStorage.setItem('source', from)
        // window.sessionStorage.setItem('path', route.path)
        // window.location.href = faceAddr
        // const { bizToken, faceUrl } = data
        // window.sessionStorage.setItem('bizToken', bizToken)
        // window.location.href = faceUrl
      } catch (error) {
        console.error(error);
      }
    };
    //检测相机是否开启
    const cameraOpen = async () => {
      if (isIOS) {
        const isOpen = await checkCamera();
        console.log('isOpen: ', isOpen);
        if (isOpen === 'Authorized') {
          // 已授权
          return true;
        } else if (isOpen === 'Denied') {
          //已经拒绝
          showConfirmDialog({
            title: '温馨提示',
            message: '未开启相机权限无法进行实名认证，请前往设置里授权相机权限。'
          }).then(() => {
            // on confirm
            console.log('前往设置授权');
            settingController();
            return false;
          }).catch(() => {
            // on cancel
            console.log('再次拒绝授权');
            return false;
          });
        } else if (isOpen === 'unknown') {
          //未知状态
          console.log('未知状态');
          return false;
        }
      } else {
        return true;
      }
    };
    watch(() => router.currentRoute.value.path, toPath => {
      console.info('监听路由 实名认证', toPath);
      fullScreen();
      from.value = route.query.from || '';
      // 获取隐私协议版本号和协议代码
      getAgreement();
    }, {
      immediate: true,
      deep: true
    });
    function handlePageShow() {
      console.info('页面pageShow事件触发了');
    }
    function handlePageHide() {
      console.info('页面pageHide事件触发了');
    }
    const onShow = () => {
      console.info('onShow触发了');
      window.removeEventListener('pageshow', handlePageShow);
      window.removeEventListener('pagehide', handlePageHide);
      window.addEventListener('pageshow', handlePageShow);
      window.addEventListener('pagehide', handlePageHide);
    };
    onShow();
    onMounted(() => {
      fullScreen();
      from.value = route.query.from || '';
      // 获取隐私协议版本号和协议代码
      getAgreement();
    });
    return (_ctx, _cache) => {
      const _component_NavBar = _resolveComponent("NavBar");
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_field = _resolveComponent("van-field");
      const _component_CellCard = _resolveComponent("CellCard");
      const _component_van_checkbox = _resolveComponent("van-checkbox");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NavBar, {
        title: "实名认证",
        "back-to-close": from.value !== 'h5'
      }, null, 8, ["back-to-close"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_image, {
        width: "100%",
        height: "3.2rem",
        src: require('@/assets/image/verification-main-img.png')
      }, null, 8, ["src"])]), _createVNode(_component_CellCard, null, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          class: "input",
          modelValue: userInfo.idcardName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => userInfo.idcardName = $event),
          placeholder: "请输入用户姓名",
          label: "姓名"
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          class: "input",
          modelValue: userInfo.idcardNumber,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => userInfo.idcardNumber = $event),
          placeholder: "请输入用户身份证号",
          label: "证件号码"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_checkbox, {
        modelValue: agreementChecked.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => agreementChecked.value = $event)
      }, {
        icon: _withCtx(props => [_createElementVNode("img", {
          class: "checkbox-icon",
          src: props.checked ? _unref(agreementCheckedImg) : _unref(agreementUncheckedImg)
        }, null, 8, _hoisted_8)]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createTextVNode(" 您知悉并同意我们基于金融监管要求和防止您的权益被冒用的目的，将您的姓名、身份证号、等提供给北京中盾安信科技发展有限公司，通过实名认证服务对您进行身份识别和认证。详见 "), _createElementVNode("span", {
          onClick: _withModifiers(openAgreement, ["stop"])
        }, " 《阳光保险在线网络平台隐私政策》、 ", 8, _hoisted_6), _createElementVNode("span", {
          onClick: _withModifiers(openPassport, ["stop"])
        }, " 《阳光统一用户认证服务协议》 ", 8, _hoisted_7)])]),
        _: 1
      }, 8, ["modelValue"])]), _createVNode(_unref(MainButton), {
        disabled: disabled.value,
        onClick: goVerify
      }, {
        default: _withCtx(() => [_createTextVNode("去认证")]),
        _: 1
      }, 8, ["disabled"])]), _createVNode(_unref(AgreementView), {
        show: agreementViewShow.value,
        "onUpdate:show": _cache[3] || (_cache[3] = $event => agreementViewShow.value = $event),
        message: agreementHtml.value,
        messageUrl: agreementUrl.value
      }, null, 8, ["show", "message", "messageUrl"])]);
    };
  }
});